<script setup lang="ts">
import type { PrivacyTermsStatementProps } from '.';

import { useI18n } from 'vue-i18n';

import contactFormLocale from '~/components/ContactFormModal/ContactFormModal.locale.json';

const props = withDefaults(defineProps<PrivacyTermsStatementProps>(), {
	class: '',
	textClass:
		'mt-3 flex cursor-default flex-wrap justify-start gap-[6px] text-center text-xs leading-normal text-primary-light-1',
	linkClass: 'underline decoration-primary-light-1 underline-offset-[6px]',
	messages: () => contactFormLocale
});

const { t } = useI18n({
	useScope: 'local',
	messages: props.messages
});

const TERMS_OF_USE_TOKEN = '{termsOfUse}';
const PRIVACY_POLICY_TOKEN = '{privacyPolicy}';

const statementParts = computed(() =>
	t('privacyPolicyStatement', {
		termsOfUse: TERMS_OF_USE_TOKEN,
		privacyPolicy: PRIVACY_POLICY_TOKEN
	})
		.split(/({termsOfUse}|{privacyPolicy})/g)
		.filter(Boolean)
);

const emit = defineEmits<{
	(e: 'terms-click'): void;
	(e: 'privacy-click'): void;
}>();

function handleTermsClick() {
	props.onTermsClick?.();
	emit('terms-click');
}

function handlePrivacyClick() {
	props.onPrivacyClick?.();
	emit('privacy-click');
}
</script>

<template>
	<p :class="[textClass, props.class]">
		<template v-for="(part, index) in statementParts" :key="`${part}-${index}`">
			<NuxtLink
				v-if="part === TERMS_OF_USE_TOKEN"
				to="/termos-de-uso"
				:class="linkClass"
				target="_blank"
				@click="handleTermsClick"
			>
				{{ t('termsOfUseLabel') }}
			</NuxtLink>

			<NuxtLink
				v-else-if="part === PRIVACY_POLICY_TOKEN"
				to="/politica-de-privacidade"
				:class="linkClass"
				target="_blank"
				@click="handlePrivacyClick"
			>
				{{ t('privacyPolicyLabel') }}
			</NuxtLink>

			<template v-else>{{ part }}</template>
		</template>
	</p>
</template>
